import moment from "moment";
import { commonUtils } from "../../_common";
import { marpolUtils } from "../marpol";
import { TMARPOLTank, TMARPOLTankWithObservedQuantity } from "../marpol/@types";
import {
	EORB1RecordCode,
	EORB1RecordState,
	TORB1BackendRecord,
	TORB1OperationAlert,
	TORB1Record,
	TORB1RecordUser,
} from "./@types";
import { ORB1_GROUPZ_DEFAULTS, TORB1GroupZ } from "./groups/group-z";

const orb1Utils = {
	getRequiredAlert(alerts: TORB1OperationAlert[]) {
		return alerts.reduce<TORB1OperationAlert | undefined>(
			(result, currentAlert) => {
				if (currentAlert.type === "REQUIRED_FIELD") result = currentAlert;
				return result;
			},
			undefined
		);
	},
	getErrorAlerts(alerts: TORB1OperationAlert[]) {
		return alerts.reduce<TORB1OperationAlert[]>((result, currentAlert) => {
			if (currentAlert.type === "ERROR") return [...result, currentAlert];
			return result;
		}, []);
	},
	getProcessedTankAlerts(alerts: TORB1OperationAlert[]) {
		return alerts.reduce<TORB1OperationAlert[]>((result, currentAlert) => {
			if (currentAlert.type === "OBSERVED_QUANTITY_ALERT")
				return [...result, currentAlert];
			return result;
		}, []);
	},
	getIdsWithErrorAlerts(alerts: TORB1OperationAlert[]): string[] {
		const ids: string[][] = alerts.map((alert) => {
			let listItemIds: string[] = [];
			const actionId: string = alert.action ? alert.action.link : "";
			if (
				(alert.type === "ERROR" || alert.type === "REQUIRED_FIELD") &&
				alert.listOfItems
			)
				listItemIds = alert.listOfItems.map((item) => `${item.link}`);
			return [...listItemIds, actionId];
		});
		return ids.reduce((result, currentIdList) => {
			return [...result, ...currentIdList];
		}, []);
	},

	isORB1RecordPresentAsPerState(orb1RecordState?: EORB1RecordState) {
		if (!orb1RecordState) return false;
		return (
			orb1RecordState === EORB1RecordState.SUBMITTED ||
			orb1RecordState === EORB1RecordState.VERIFIED ||
			orb1RecordState === EORB1RecordState.APPROVED
		);
	},
	isORB1RecordOfInventoryType(orb1Record?: TORB1Record) {
		if (!orb1Record) return false;
		return (
			orb1Record.recordCode === EORB1RecordCode.ORB1C1 ||
			orb1Record.recordCode === EORB1RecordCode.ORB1I3
		);
	},

	generateBilgeHoldingRemarkIfPresent(
		tank: TMARPOLTank,
		isPrimaryBilgeTankPresent: boolean
	) {
		// if (!isPrimaryBilgeTankPresent) return tank.tankName;
		// if (tank.tankName === 'BILGE HOLDING TANK' || tank.tankCode === 'BHT')
		//     return 'BILGE HOLDING TANK TRANSFERRED VIA PRIMARY BILGE TANK';
		return tank.tankName;
	},
};

export default orb1Utils;
